import { BaseResource } from '../base-resource';
import { ItemUserDefinedField } from '../user-defined-field/item-user-defined-field';
import {ItemAssets} from '../item/item';

export class Item extends BaseResource {
    constructor() {
        super();
        this.type = "generaladmissionitem";
    }
  itemAssets: ItemAssets[];
}
